import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_FETCH_DOMAINS,
} from '../../../../actions/actionTypes';
import {
  DOMAINS_PLATFORMS_TREE_CHILDREN_KEY,
  DOMAINS_PLATFORMS_TREE_PARENT_KEY,
} from '../../../../config/testPurchaseConfiguration';

const domains = fetchReducerGenerator(
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_FETCH_DOMAINS
);

export default domains;

const reduceDomainPlatformsToAvailableIds = (
  availableIds,
  { domainPlatform, domains }
) => {
  availableIds.availableDomainPlatformIds.push(domainPlatform.domainPlatformId);
  availableIds.availableDomainIds.push(
    ...domains.map(({ domainId }) => domainId)
  );
  return availableIds;
};

export const getTestPurchaseDomainsAvailableIds = state =>
  (state.response.data ?? []).reduce(reduceDomainPlatformsToAvailableIds, {
    availableDomainPlatformIds: [],
    availableDomainIds: [],
  });

const mapTreeSelectDomains = domain => {
  const domainTitle = `${domain.url} (${domain.counter})`;
  const domainValue = `${DOMAINS_PLATFORMS_TREE_CHILDREN_KEY}_${domain.domainId}`;
  return {
    title: domainTitle,
    key: domainValue,
    value: domainValue,
  };
};

const mapTreeSelectDomainPlatforms = ({ counter, domains, domainPlatform }) => {
  const platformTitle = `${domainPlatform.name} (${counter})`;
  const platformValue = `${DOMAINS_PLATFORMS_TREE_PARENT_KEY}_${domainPlatform.domainPlatformId}`;
  return {
    title: platformTitle,
    key: platformValue,
    value: platformValue,
    children: (domains ?? []).map(mapTreeSelectDomains),
  };
};

export const getTestPurchaseDomainsTreeData = state =>
  (state.response.data ?? []).map(mapTreeSelectDomainPlatforms);
